import {
  IEntity,
  JsonApiQueryParameters,
  formatQueryForJsonApi,
  prepareHeaders,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export type IInitiative = IEntity;

export enum InitiativeTypeFilters {
  ids = 'ids',
  isCrm = 'isCrm',
  active = 'active',
}

export interface IInitiativeType extends IEntity {
  active: 1 | 0;
  acronym: string;
}

// Define a service using a base URL and expected endpoints
export const initiativesApi = createApi({
  reducerPath: 'initiatives',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/initiatives`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Initiative', 'InitiativeType'],
  endpoints: (builder) => ({
    getInitiatives: builder.query<
      { values: IInitiative[]; total: number; ids: string[] },
      JsonApiQueryParameters
    >({
      providesTags: ['Initiative'],
      query: formatQueryForJsonApi,
      transformResponse: transformResponseFromJsonApi<IInitiative>,
    }),
    getInitiativeTypes: builder.query<
      { values: IInitiativeType[]; total: number },
      JsonApiQueryParameters
    >({
      providesTags: ['InitiativeType'],
      query: (params) => formatQueryForJsonApi(params, 'initiative-types'),
      transformResponse: transformResponseFromJsonApi<IInitiativeType>,
    }),
  }),
});

export const { useGetInitiativesQuery, useGetInitiativeTypesQuery } =
  initiativesApi;
